import React from 'react'

import { Flag } from '@phosphor-icons/react'
import { SectionContainer } from 'Components/Blocks'

import Gallery from './Gallery'
import { Container, IconHolder } from './styles'
import Title from './Title'

type Props = {
  onAction?: () => void
}

function HomeHeroSection({ onAction }: Props) {
  return (
    <SectionContainer>
      <Container
        flexDirection={[
          'column',
          'column',
          'column',
          'column',
          'column',
          'row',
        ]}
        gap={[0, 0, 0, 0, 0, 5]}
        maxHeight={['unset', 'unset', 'unset', 'unset', 'unset', 550]}
        pt={[0, 0, 5]}
      >
        <Title onAction={onAction} />

        <Gallery />

        <IconHolder>
          <Flag size={24} weight="fill" />
        </IconHolder>
      </Container>
    </SectionContainer>
  )
}

export default HomeHeroSection
